export default __webpack_public_path__ + "static/install-istio-8fcffb733002ef0b438edaf32a0bcff5.webp";